import React from 'react';

const Pagenotfound = () => (
  <div>
    Page Not Found 404
  </div>
);

export default Pagenotfound;
